export default __webpack_public_path__ + "static/media/2324 knife block B top.3d9a0acd.png";